import Vue from 'vue';
import VueI18n from 'vue-i18n';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enUS from './en-US';
import zhCN from './zh-CN';
import { localStg } from '@/utils/storage/local';

Vue.use(VueI18n);

// 语言存储的key
const LOCALE_KEY = 'app_locale';

// 获取默认语言
function getDefaultLocale() {
    // 优先从本地存储获取
    const savedLocale = localStg.get(LOCALE_KEY);
    if (savedLocale) {
        return savedLocale;
    }
    // 其次根据浏览器语言判断
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang.startsWith('zh')) {
        return 'zh-CN';
    }
    return 'en-US';
}

const messages = {
    'zh-CN': {
        ...zhCN,
        ...elementZhLocale
    },
    'en-US': {
        ...enUS,
        ...elementEnLocale
    }
};

const i18n = new VueI18n({
    locale: getDefaultLocale(),
    fallbackLocale: 'zh-CN',
    messages,
    silentTranslationWarn: true
});

// 切换语言的方法
export function setLocale(locale) {
    i18n.locale = locale;
    localStg.set(LOCALE_KEY, locale);
    document.querySelector('html').setAttribute('lang', locale);
}

// 获取当前语言
export function getLocale() {
    return i18n.locale;
}

// 可用的语言列表
export const localeOptions = [
    { label: '中文', value: 'zh-CN' },
    { label: 'English', value: 'en-US' }
];

export default i18n;
